/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FinalPayorDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FinalPayorDiscount({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/FinalPayorDiscount"
  
}) {
let paymentPlanFinalDiscountAmountValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'final_discount.amount',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="FinalPayorDiscount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Final discount applied"
 weight="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.final_discount.amount"
 format="/Data/format.js numberMoney"
 text={paymentPlanFinalDiscountAmountValueData}
 weight="medium"
/>
</div>
{children}
</React.Fragment>)
}